module.exports = __webpack_public_path__ + "static/media/Lato-Bold.a47d8f9c.eot";